// © Microsoft Corporation. All rights reserved.

import { DesignSystem, accentFillRest, isDarkMode, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

export const GradientOverlayStyles = (config: DesignSystem) =>  ({
    gradientOverlayContainer: {
        "& .cwt-overlay": {
            position: "fixed",
            width: "100vw",
            height: "50vh",
            bottom: "0",
            transition: "background-position .4s ease",
            cursor: "pointer",
            [applyLocalizedProperty("left", "right", config.direction)]: "0",
            background: isDarkMode(config) ?
                "linear-gradient(180deg, rgba(66, 66, 66, 0), rgba(66, 66, 66, 1))" :
                "linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))",
            "background-repeat": "no-repeat",
            "z-index": "2147483645",

            "&:hover": {
                "background-position": "0px 3vh"
            }
        }
    },

    overlayButton: {
        padding: "10px 100px",
        border: "1px solid",
        color: accentFillRest,
        background: neutralLayerCard,
        margin: "20px 0",
        cursor: "pointer",
        "font-size": "16px",
        "border-color": accentFillRest,
        "border-radius": "30px",
        position: "fixed",
        [applyLocalizedProperty("left", "right", config.direction)]: "50%",
        [applyLocalizedProperty("right", "left", config.direction)]: "unset",
        transform: applyLocalizedProperty("translateX(-50%)", "translateX(50%)", config.direction),
        bottom: "20px",
        "max-width": "95vw"
    }
});